import styled from "@emotion/styled";
import { ModalBody } from "./ValuesSourceModal.styled";

export const ModalBodyWithSearch = styled(ModalBody)`
  display: flex;
  flex-direction: column;
`;

export const SearchInputContainer = styled.div`
  margin-bottom: 1rem;
`;

export const DataPickerContainer = styled.div`
  overflow-y: auto;
`;
